import { HttpException, isPlainObject, serializeHttpException } from '@sortlist-frontend/utils';

export type SerializedError = {
  __type: 'SerializedError';
  status: number | null;
  errorClass: string | null;
  message: string | null;
  url: string | null;
  method: string | null;
  stackTrace: string | null;
  previousErrorMessage: string | null;
};

export const isSerializedError = (val: unknown): val is SerializedError => {
  return isPlainObject(val) && val['__type'] === 'SerializedError';
};

export const serializeError = (e: Error | HttpException): SerializedError => {
  if (e instanceof HttpException) {
    return serializeHttpException(e);
  }
  const { message = null, stack } = e;
  return {
    __type: 'SerializedError',
    message,
    errorClass: e.constructor?.name ?? 'Error',
    status: null,
    url: null,
    method: null,
    stackTrace: stack ?? null,
    previousErrorMessage: null,
  };
};
